import axios from "axios";
import { configRequest, osapiRequest, messengerRequest, osAnalyticsRequest } from "Auth/auth-config";
import config from "config";
import { selectEdgePin } from "../ducks/authenticationDuck";

// Lazy store getter to avoid circular dependency (store → configTier → customersDuck → apiActions → store)
let _store = null;
const getStore = () => {
  if (!_store) {
    _store = require("Store").default;
  }
  return _store;
};

import {
  getAllDeviceAlarmsHistoryUrl,
  getDeviceHistoryUrl,
  sendCommandUrl,
  getSettingUrl,
  setSettingUrl,
  configurationUrl,
  refreshSignalRUrl,
  postCustomersUrl,
  trendRange,
  getAllAlarmLimits,
  updateAlarmLimits,
  restoreDefaultAlarmLimits,
  getAlarmLimits,
  getGraphicsUrl,
  getReportRangeUrl,
  resendReportsUrl,
  getDeviceParamaters,
  updateDeviceParamater,
  getSensorName,
  updateSensorName,
  newTrendUrl,
  // trendPreLoadShortUrl, // DISABLED
  // trendPreLoadLongUrl,  // DISABLED
  influxLoadRangeUrl,
  influxLoadStatusUrl,
  influxQueryRangeUrl,
  influxHotpathBackfillUrl,
  getIotModules,
  sendIotModuleCommand,
  clearAlarm,
  clearAllAlarms,
  toggleAllAlarmsHandlingForDevice,
  toggleSingleAlarm,
  pincodeStatusUrl,
  pincodeValidateUrl,
  pincodeChangeUrl,
  pincodeRemoveUrl,
  createNewAlarmUrl,
  deleteCustomAlarmUrl,
} from "./../constants/apiUrl";

axios.defaults.headers.post["Content-Type"] = "application/json";

// Helper function to add edge authentication if needed
const addEdgeAuth = (requestConfig = {}) => {
  if (config.APP_ENV === "Edge") {
    const edgePin = selectEdgePin(getStore().getState());
    if (edgePin) {
      return {
        ...requestConfig,
        headers: {
          ...requestConfig.headers,
          'Authorization': `PIN ${edgePin}`
        }
      };
    }
  }
  return requestConfig;
};

const requests = {
  get: (url, params) => axios.get(url, addEdgeAuth(params)).then((res) => res.data),
  getRaw: (url, params) => axios.get(url, addEdgeAuth(params)),
  post: (url, body, config) => axios.post(url, body, addEdgeAuth(config)).then((res) => res.data),
  postRaw: (url, body, config) => axios.post(url, body, addEdgeAuth(config)),
  // put: (url, body, config) => axios.put(url, body, config).then(res => res.data),
  // delete: url => axios.delete(url).then(res => res.data),
};

export const Settings = {
  get: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${getSettingUrl}`, body, {
      ...config,
      scope: osapiRequest,
    }),
  post: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${setSettingUrl}`, body, {
      ...config,
      scope: osapiRequest,
    }),
};

export const DevicesConfig = {
  get: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${configurationUrl}`, body, {
      ...config,
      scope: configRequest,
    }),
};

export const Trends = {
  get: (baseUrl, body, filter, config) =>
    requests.post(`${baseUrl}${getDeviceHistoryUrl}`, body, {
      ...config,
      scope: osapiRequest,
    }),
};

export const TrendsWithRange = {
  get: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${newTrendUrl}`, body, {
      ...config,
      scope: osAnalyticsRequest,
    }),
};

// DISABLED - Old preload endpoints no longer used with new InfluxDB integration
// export const TrendPreLoadShort = {
//   post: (baseUrl, body, config) =>
//     requests.post(`${baseUrl}${trendPreLoadShortUrl}`, body, {
//       ...config,
//       scope: osAnalyticsRequest,
//     }),
// };

// export const TrendPreLoadLong = {
//   post: (baseUrl, body, config) =>
//     requests.post(`${baseUrl}${trendPreLoadLongUrl}`, body, {
//       ...config,
//       scope: osAnalyticsRequest,
//     }),
// };

// New InfluxDB API Actions
export const InfluxLoadRange = {
  post: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${influxLoadRangeUrl}`, body, {
      ...config,
      scope: osAnalyticsRequest,
    }),
};

export const InfluxHotpathBackfill = {
  post: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${influxHotpathBackfillUrl}`, body, {
      ...config,
      scope: osAnalyticsRequest,
    }),
};

export const InfluxLoadStatus = {
  get: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${influxLoadStatusUrl}`, body, {
      ...config,
      scope: osAnalyticsRequest,
    }),
};

export const InfluxQueryRange = {
  get: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${influxQueryRangeUrl}`, body, {
      ...config,
      scope: osAnalyticsRequest,
    }),
};

export const RefreshSignalR = {
  post: (baseUrl, body) =>
    requests.post(`${baseUrl}${refreshSignalRUrl}`, body, {
      scope: messengerRequest,
    }),
};

export const Commands = {
  post: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${sendCommandUrl}`, body, {
      ...config,
      scope: osapiRequest,
    }),
};

export const Reports = {
  post: (baseUrl, body, config) => requests.post(`${baseUrl}`, body, { ...config, scope: osapiRequest }),
  getReportsWithTimeRange: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${getReportRangeUrl}`, body, {
      ...config,
      scope: osapiRequest,
    }),
  resendReports: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${resendReportsUrl}`, body, {
      ...config,
      scope: osapiRequest,
    }),
};

export const Alarms = {
  getAllAlarmsHistory: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${getAllDeviceAlarmsHistoryUrl}`, body, {
      ...config,
      scope: osapiRequest,
    }),
  clearAlarm: (baseUrl, body, config) =>
    requests.postRaw(`${baseUrl}${clearAlarm}`, body, {
      ...config,
      scope: osapiRequest,
    }),
  clearAllAlarms: (baseUrl, body, config) =>
    requests.postRaw(`${baseUrl}${clearAllAlarms}`, body, {
      ...config,
      scope: osapiRequest,
    }),
};

export const AlarmLimits = {
  get: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${getAlarmLimits}`, body, {
      ...config,
      scope: osapiRequest,
    }),
  getAll: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${getAllAlarmLimits}`, body, {
      ...config,
      scope: osapiRequest,
    }),
  update: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${updateAlarmLimits}`, body, {
      ...config,
      scope: osapiRequest,
    }),
  restore: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${restoreDefaultAlarmLimits}`, body, {
      ...config,
      scope: osapiRequest,
    }),
  toggleSingle: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${toggleSingleAlarm}`, body, {
      ...config,
      scope: osapiRequest,
    }),
  toggleAllForDevice: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${toggleAllAlarmsHandlingForDevice}`, body, {
      ...config,
      scope: osapiRequest,
    }),
};

export const CustomerConfig = {
  get: (baseUrl, body, config) =>
    requests.post(`${baseUrl}/api/sites`, body, {
      ...config,
      scope: configRequest,
    }),
  post: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${postCustomersUrl}`, body, {
      ...config,
      scope: configRequest,
    }),
};

export const Graphics = {
  get: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${getGraphicsUrl}`, body, {
      ...config,
      scope: configRequest,
    }),
};

export const DeviceParamaters = {
  get: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${getDeviceParamaters}`, body, {
      ...config,
      scope: osapiRequest,
    }),
  post: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${updateDeviceParamater}`, body, {
      ...config,
      scope: osapiRequest,
    }),
};

export const SensorName = {
  get: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${getSensorName}`, body, {
      ...config,
      scope: osapiRequest,
    }),
  post: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${updateSensorName}`, body, {
      ...config,
      scope: osapiRequest,
    }),
};

export const IotModules = {
  get: (baseUrl, body, config) =>
    requests.getRaw(`${baseUrl}${getIotModules}`, body, {
      ...config,
      scope: osapiRequest,
    }),
  // sendCommand: (baseUrl, body, config) =>
  //   requests.postRaw(`${baseUrl}${sendIotModuleCommand}`, body, {
  //     ...config,
  //     scope: osapiRequest,
  //   }),
};

export const sensorManagement = {
  get: (baseUrl, body, config) =>
    requests.postRaw(`${baseUrl}/api/readsensorconfig`, body, {
      ...config,
      scope: configRequest,
    }),
  getSensorsForEdgeUnit: (baseUrl, body, config) =>
    requests.postRaw(`${baseUrl}/api/getsensorconfigs`, body, {
      ...config,
      scope: configRequest,
    }),
  post: (baseUrl, body, config) =>
    requests.postRaw(`${baseUrl}/api/createsensorconfig`, body, {
      ...config,
      scope: configRequest,
    }),
  put: (baseUrl, body, config) =>
    requests.postRaw(`${baseUrl}/api/updatesensorconfig`, body, {
      ...config,
      scope: configRequest,
    }),
  delete: (baseUrl, body, config) =>
    requests.postRaw(`${baseUrl}/api/deletesensorconfig`, body, {
      ...config,
      scope: configRequest,
    }),
};

export const CustomAlarms = {
  create: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${createNewAlarmUrl}`, body, {
      ...config,
      scope: osapiRequest,
    }),
  remove: (baseUrl, body, config) =>
    requests.post(`${baseUrl}${deleteCustomAlarmUrl}`, body, {
      ...config,
      scope: osapiRequest,
    }),
};

export const pincodeApi = {
  getStatus: (baseUrl) =>
    requests.get(`${baseUrl}${pincodeStatusUrl}`),
  validate: (baseUrl, pincode) =>
    axios.post(`${baseUrl}${pincodeValidateUrl}`, null, {
      headers: { 'Authorization': `PIN ${pincode}` }
    }),
  change: (baseUrl, newPincode) =>
    requests.post(`${baseUrl}${pincodeChangeUrl}`, { newPincode }),
  remove: (baseUrl) =>
    requests.post(`${baseUrl}${pincodeRemoveUrl}`, null),
};